var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"fileIndex":_vm.fileIndex,"uploading":_vm.uploading,"errors":_vm.errors,"message":_vm.message,"retry":_vm.uploadAllFiles,"cancel":_vm.cancel,"percentage":_vm.percentage,"total":_vm.total,"uploaded":_vm.uploaded})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }